import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { useAuth } from "@/auth/use-auth";
import NotFoundPage from "@/catchall";

export const Route = createFileRoute("/_private/_patient-360")({
  component: PatientLayout,
});

function PatientLayout() {
  const { authUser } = useAuth();
  const { pathname } = useLocation();
  const permissions = authUser?.permissions ?? [];

  // The analytics page requires patient_360_analytics or entity_finance;
  // every other patient-360 page requires the base patient_360 permission.
  const isAnalyticsRoute = pathname.startsWith("/patient360-analytics");
  const allowed = isAnalyticsRoute
    ? permissions.includes("patient_360_analytics") ||
      permissions.includes("entity_finance")
    : permissions.includes("patient_360");

  return allowed ? <Outlet /> : <NotFoundPage />;
}
